import { useQueryClient } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";

export const useRefetchCandidacySummaryChanges = () => {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();
  const queryClient = useQueryClient();

  return ({ candidacyId }: { candidacyId: string }) => {
    void queryClient.refetchQueries({
      queryKey: [
        "candidacy_summary_changes",
        currentCompanyId,
        currentJobId,
        candidacyId,
      ],
    });
  };
};
